import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=632227b5&scoped=true&"
import script from "./screen.vue?vue&type=script&lang=js&"
export * from "./screen.vue?vue&type=script&lang=js&"
import style0 from "./screen.vue?vue&type=style&index=0&lang=less&"
import style1 from "./screen.vue?vue&type=style&index=1&id=632227b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632227b5",
  null
  
)

export default component.exports